import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChatMessage } from "@/components/chat/ChatMessage";

const when = (iso) => new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });

export const ClientChatHistory = ({ clientId }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/chat/client/${clientId}`).then((r) => setD(r.data.sessions)).catch(() => setD([])); }, [clientId]);
  if (!d) return <div className="py-6 text-center text-xs text-slate-500">Carregando...</div>;
  if (!d.length) return <div data-testid="client-chat-empty" className="py-6 text-center text-xs text-slate-500">Este cliente ainda não usou o chat do site.</div>;
  return (
    <div data-testid="client-chat-history" className="space-y-4">
      {d.map((s) => (
        <div key={s.id} className="rounded-lg border border-[#1F293D] bg-[#111827] p-3">
          <div className="mb-2 text-[11px] text-slate-500">
            Chat de {when(s.created_at)} · {s.status === "attended" ? `atendido por ${s.attended_by}` : "em aberto"}
          </div>
          <div className="space-y-1.5">{s.messages.map((m) => <ChatMessage key={m.id} m={m} />)}</div>
        </div>
      ))}
    </div>
  );
};
